module.exports = function getResource(label) {
    const resources = {
        removePhoto: 'Remove Photo',
        addPhoto: 'Add Photo'
    };
    return resources[label];
};
